import { SetOwner } from '@adaptiva/core/common';
import { provideBaseWidget } from '@adaptiva/core/widgets';
import { BaseEditorError, EEditorErrorType, IBaseEditorError } from '@adaptiva/data-service';
import { ComboComponent } from '@adaptiva/widgets/combo';
import { InputComponent } from '@adaptiva/widgets/input';
import { ToggleSwitchComponent } from '@adaptiva/widgets/toggle-switch';
import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { BaseScheduleTypeComponent } from '../base-schedule-type.component';

@Component({
	standalone: false,
	selector: 'app-recurring-by-day-of-week',
	templateUrl: './recurring-by-day-of-week.component.html',
	providers: [provideBaseWidget(() => RecurringByDayOfWeekComponent)],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecurringByDayOfWeekComponent extends BaseScheduleTypeComponent {

	@ViewChild('RecurringIntervalInMonthsInput')
	@SetOwner recurringIntervalInMonthsInput: InputComponent;

	@ViewChild('DayOfTheWeekInput')
	@SetOwner dayOfTheWeekInput: ComboComponent;

	@ViewChild('WeekOfTheMonthInput')
	@SetOwner weekOfTheMonthInput: InputComponent;

	@ViewChild('IsLastWeekToggle')
	@SetOwner isLastWeekToggle: ToggleSwitchComponent;

	public isLastWeek = false;

	public numberOfMonths = 1;

	public weekOfMonth = 1;

	public dayOfWeek = 0;

	public dayOptions = [
		{ display: 'Sunday', value: 0 },
		{ display: 'Monday', value: 1 },
		{ display: 'Tuesday', value: 2 },
		{ display: 'Wednesday', value: 3 },
		{ display: 'Thursday', value: 4 },
		{ display: 'Friday', value: 5 },
		{ display: 'Saturday', value: 6 }
	];

	public validate(): IBaseEditorError[] {
		const _errors: IBaseEditorError[] = [];

		if (this.numberOfMonths < 1) {
			_errors.push(
				new BaseEditorError(
					EEditorErrorType.Error,
					this.guid,
					['RecurringIntervalInMonthsInput', 'Number of months must be greater than 0']
				)
			);
		}

		if (this.weekOfMonth < 1) {
			_errors.push(
				new BaseEditorError(
					EEditorErrorType.Error,
					this.guid,
					['WeekOfTheMonthInput', 'Week of month must be greater than 0']
				)
			);
		}

		return _errors;
	}

	public commitModelToView(): void {
		if (this.schedule) {
			this.numberOfMonths = this.schedule.numberOfMonths;
			this.weekOfMonth = this.schedule.weekOfMonth;
			this.isLastWeek = this.schedule.lastWeekOfMonth;
			this.dayOfWeek = this.schedule.dayOfWeek || 0;

			setTimeout(() => {
				this.dayOfTheWeekInput.setValue(this.dayOfWeek);
			});
		}
	}

	// event listeners start

	public setIsLastWeek(event: boolean): void {
		this.isLastWeek = event;

		this.outputChanges([
			{ propertyName: 'lastWeekOfMonth', value: this.isLastWeek }
		]);
	}

	public setNumberOfMonths(event: string): void {
		const months = +event;

		if (months !== this.numberOfMonths) {
			this.numberOfMonths = months;
			this.outputChanges([
				{ propertyName: 'numberOfMonths', value: this.numberOfMonths }
			]);
		}
	}

	public setWeekOfMonth(event: string): void {
		const week = +event;

		if (week !== this.weekOfMonth) {
			this.weekOfMonth = week;
			this.outputChanges([
				{ propertyName: 'weekOfMonth', value: this.weekOfMonth > 4 ? 4 : this.weekOfMonth }
			]);
		}
	}

	public setDayOfWeek(event: any): void {
		const day = +event;

		if (day !== this.dayOfWeek) {
			this.dayOfWeek = day;
			this.outputChanges([
				{ propertyName: 'dayOfWeek', value: this.dayOfWeek }
			]);
		}
	}
	// event listeners end

}
